"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _components = require("../../components");

var _TrialPopup = require("../../EpicEula/TrialPopup");

var _TrialPopup2 = _interopRequireDefault(_TrialPopup);

var _utils = require("./../../utils");

var _user = require("../../redux/modules/user");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activating: state.user.activatingTrial,
    activated: state.user.activatedTrial,
    error: state.user.trialError,
    user: state.user,
    softwares: state.softwares
  };
}, { activateTrial: _user.activateTrial }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Popup, _React$Component);

  function Popup(props) {
    (0, _classCallCheck3.default)(this, Popup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Popup.__proto__ || (0, _getPrototypeOf2.default)(Popup)).call(this, props));

    _this.onTrialClick = _this.onTrialClick.bind(_this);
    _this.onClickContactUs = _this.onClickContactUs.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Popup, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        if (localStorage.getItem("closedTrialPopup") === "false" || localStorage.getItem("closedExpiredTrialPopup") === "false") {
          var localStorageFlag = this.props.trailExpired ? "closedExpiredTrialPopup" : "closedTrialPopup";
          localStorage.setItem(localStorageFlag, true);
        }
      }
    }
  }, {
    key: "onTrialClick",
    value: function onTrialClick() {
      var activateTrial = this.props.activateTrial;

      activateTrial();
    }
  }, {
    key: "onClickContactUs",
    value: function onClickContactUs() {
      var dialogs = this.context.dialogs;

      dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: "Contact Us",
        description: "",
        tag: "contact-us",
        initialValues: {
          name: _ramda2.default.propOr("", "name", ""),
          email: _ramda2.default.propOr("", "email", this.props.user.email),
          subject: _ramda2.default.propOr("", "subject", "Contact Us from free Trial Expired."),
          comment: _ramda2.default.propOr("", "comment", "")
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          activated = _props.activated,
          trailExpired = _props.trailExpired,
          custom = _props.custom,
          onCloseYes = _props.onCloseYes;


      if (!custom) {
        if (activated) {
          return _react2.default.createElement(_TrialPopup2.default.Welcome, { onCloseYes: onCloseYes });
        }

        if (trailExpired) {
          return _react2.default.createElement(_TrialPopup2.default.Expired, { onCloseYes: onCloseYes });
        }

        return _react2.default.createElement(_TrialPopup2.default, { onTrialClick: this.onTrialClick, onCloseYes: onCloseYes });
      } else {
        return _react2.default.createElement(_TrialPopup2.default.Custom, {
          contactUsPopup: this.onClickContactUs,
          onCloseYes: onCloseYes
        });
      }
    }
  }]);
  return Popup;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
var TrialPopup = (_dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    loggedIn: state.auth.loggedIn
  };
}, { activateTrial: _user.activateTrial }), _dec2(_class3 = (_temp2 = _class4 = function (_React$Component2) {
  (0, _inherits3.default)(TrialPopup, _React$Component2);

  function TrialPopup(props) {
    (0, _classCallCheck3.default)(this, TrialPopup);
    return (0, _possibleConstructorReturn3.default)(this, (TrialPopup.__proto__ || (0, _getPrototypeOf2.default)(TrialPopup)).call(this, props));
  }

  (0, _createClass3.default)(TrialPopup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.user !== this.props.user) {
        console.log(nextProps.user);
        var closedTrialPopup = localStorage.getItem("closedTrialPopup") !== "false";
        var closedExpiredTrialPopup = localStorage.getItem("closedExpiredTrialPopup") !== "false";

        var loggedIn = nextProps.loggedIn;

        if (loggedIn) {
          var user = nextProps.user;

          var coupon = this.props.location && this.props.location.query && this.props.location.query.coupon;
          var subscription = user.subscription,
              megascansTrial = user.megascansTrial;

          var subscribed = subscription && subscription.isActive;
          if (!subscribed && !coupon) {
            if (_underscore2.default.isEmpty(megascansTrial)) {
              if (!closedTrialPopup) {
                this.context.dialogs.custom(_react2.default.createElement(Popup, null));
              }
            } else {
              if (!(0, _utils.isActiveSubscriber)(user)) {
                if (!closedExpiredTrialPopup) {
                  return this.context.dialogs.custom(_react2.default.createElement(Popup, { trailExpired: true }));
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", null);
    }
  }]);
  return TrialPopup;
}(_react2.default.Component), _class4.contextTypes = {
  router: _react.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp2)) || _class3);
exports.default = TrialPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TrialPopup/TrialPopup.jsx
// module id = 2830
// module chunks = 0